import React from "react";
import { Route, Redirect } from "react-router";
import { Query } from "react-apollo";
import gql from "graphql-tag";

const AUTH = gql`
  {
    viewer {
      id
      roles
      isUserAuthenticated
      specialPermissions {
        isAdmin
      }
    }
  }
`;

class PrivateRoute extends React.Component {
  componentDidUpdate(prevProps) {
    if (prevProps.rest.path !== this.props.rest.path) {
      this.props.refetch();
    }
  }

  render() {
    const isUserAuthenticated = this.props.data.viewer.isUserAuthenticated;
    const Component = this.props.component;
    let isAdmin = false;

    if (this.props.data.viewer.specialPermissions) {
      isAdmin = this.props.data.viewer.specialPermissions.isAdmin;
    }

    return (
      <Route
        {...this.props.rest}
        render={(props) => {
          if (!isUserAuthenticated || !isAdmin) {
            return <Redirect to="/login" />;
          } else {
            return <Component {...props} viewer={this.props.data.viewer} />;
          }
        }}
      />
    );
  }
}

const PrivateRouteWithAuthQuery = ({ component: Component, ...rest }) => {
  return (
    <Query query={AUTH}>
      {({ loading, error, data, refetch }) => {
        if (loading) return "Loading...";
        if (error) return `Error! ${error.message}`;

        return (
          <PrivateRoute
            data={data}
            rest={rest}
            refetch={refetch}
            component={Component}
          />
        );
      }}
    </Query>
  );
};

export default PrivateRouteWithAuthQuery;
